"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                NavBar_CompanyPickerHelpText: "(Ctrl+Shift+O)\r\nChoose a Legal Entity",
                NavBar_CurrentCompanyText: "Current company is {0} activate to choose a company",
                NavBar_Lookup: "Lookup",
            },
        });
        var Company = /** @class */ (function (_super) {
            __extends(Company, _super);
            function Company() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.getCurrentCompanyText = function () {
                    return $dyn.format($dyn.label("NavBar_CurrentCompanyText"), $dyn.value(_this.Company));
                };
                _this.click = function () {
                    _this.toggleCompanyLookupVisible();
                };
                _this.keyDown = function (event) {
                    if ($dyn.util.isShortcutKeyPressed(event, { keyCode: $dyn.ui.KeyCodes.enter })) {
                        // Prevent the keyDown from bubbling for the Enter key so the form level enter shortcut is prevented.
                        // See documentation on this behavior in $dyn.ui.Control constructor.
                        event.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut in Commpany control.");
                    }
                };
                return _this;
            }
            Company.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                // Method that gets overridden in html-binding-telemetry
                this.recordTelemetry = function () { };
                $.when($dyn.deferred.onHasValue($dyn.user)).done(function (user) {
                    // Once the user is available then observe the changes to the navigation company.
                    $dyn.observe(user.NavigationCompanyName, function () {
                        _this.CompanyName(user.CompanyName());
                    });
                    $dyn.observe(user.NavigationCompany, function () {
                        _this.Company(user.Company());
                    });
                });
                this.CompanyLookupVisible = $dyn.observable(false);
                this.CompanyLookupVisible.valueChanged.subscribe(function () {
                    if (_this.CompanyLookupVisible()) {
                        var parentWidth = _this.element.parentElement.clientWidth;
                        _this.element.style.width = parentWidth + "px";
                        _this.recordTelemetry();
                        $(document.body).on("resetShellOnNavigation.dynNavigationBarCompany", function () {
                            _this.closeLookup();
                        });
                        $(document.body).on("click.dynNavigationBarCompany", function (event) {
                            if (!$.contains(_this.element, event.target)) {
                                _this.closeLookup();
                            }
                        });
                        $dyn.setValue(_this.lookupControl, "Visible", true);
                        if (_this.companyChooserFormElement && _this.companyChooserForm) {
                            _this.companyChooserForm.takeNavigationFocus();
                            _this.companyChooserForm.Refresh();
                            $dyn.async(function () {
                                var inputElement = _this.lookupControl.$inputElement[0];
                                if (inputElement) {
                                    $dyn.ui.selectionStart(inputElement, 0);
                                    $dyn.ui.selectionEnd(inputElement, inputElement.value.length);
                                }
                            }, undefined, "Select the company text");
                        }
                        else {
                            // if this is the first time its displayed
                            _this.findCompanyLookupForm();
                        }
                    }
                    else {
                        _this.element.style.width = "auto";
                        $dyn.setValue(_this.lookupControl, "Visible", false);
                        $(document.body).off(".dynNavigationBarCompany");
                    }
                });
            };
            Company.prototype.findCompanyLookupForm = function () {
                var _this = this;
                if ($dyn.async.IsClientProcessing()) {
                    var subscriberId_1 = $dyn.clientBusy.valueChanged.subscribe(function () {
                        if (!_this.isLookupFormLoaded()) {
                            _this.findCompanyLookupForm();
                        }
                        else {
                            _this.processLookupForm();
                        }
                        $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_1);
                    });
                }
                else {
                    window.setTimeout(function () {
                        if (!_this.isLookupFormLoaded()) {
                            _this.findCompanyLookupForm();
                        }
                        else {
                            _this.processLookupForm();
                        }
                    });
                }
            };
            Company.prototype.isLookupFormLoaded = function () {
                if (!this.companyChooserFormElement) {
                    this.companyChooserFormElement = this.element.getElementsByClassName("rootContent")[0];
                }
                if (!this.companyChooserFormElement ||
                    !this.companyChooserFormElement.parentElement ||
                    !$(this.companyChooserFormElement.parentElement).attr("data-dyn-rootserverid")) {
                    return false;
                }
                else {
                    return true;
                }
            };
            Company.prototype.processLookupForm = function () {
                var _this = this;
                this.companyChooserForm = $dyn.context(this.companyChooserFormElement);
                $dyn.shell.activateElement(this.companyChooserFormElement);
                this.companyChooserForm.takeNavigationFocus();
                // find the lookup
                // this is weak and a temp fix until the lookup support hiding the button and allowing the lookup in the model
                // Deliverable 169080: Lookup: Add server/developer options to allow Lookups to maintain focus while flyout is open
                var lookupControlElement = this.companyChooserForm.findControl("DataArea_id");
                this.lookupControl = $dyn.context(lookupControlElement);
                if (this.lookupControl) {
                    this.lookupControl.SendKeyToLookup = true;
                    this.lookupControl.ShouldFlyoutTakeFocus(false);
                    // tslint:disable:object-literal-sort-keys
                    var overriddenShortcuts = {
                        Esc: {
                            Keys: { keyCode: $dyn.ui.KeyCodes.esc },
                            Handler: function () {
                                if (_this.CompanyLookupVisible()) {
                                    _this.CompanyLookupVisible(false);
                                    document.getElementById("CompanyButton").focus();
                                    return true;
                                }
                                return false;
                            },
                            RecordTelemetry: false
                        },
                        Tab: {
                            Keys: { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true },
                            Handler: function () {
                                if (_this.CompanyLookupVisible()) {
                                    _this.CompanyLookupVisible(false);
                                    document.getElementById("CompanyButton").focus();
                                    return true;
                                }
                                return false;
                            },
                            RecordTelemetry: false
                        }
                    };
                    // tslint:enable:object-literal-sort-keys
                    $dyn.util.objectAssign(this.lookupControl.Shortcuts, overriddenShortcuts);
                    $dyn.async(function () {
                        var inputElement = _this.lookupControl.$inputElement[0];
                        if (inputElement) {
                            $dyn.ui.selectionStart(inputElement, 0);
                            $dyn.ui.selectionEnd(inputElement, inputElement.value.length);
                        }
                    }, undefined, "Select the company text in process lookup");
                }
            };
            Company.prototype.closeLookup = function () {
                this.CompanyLookupVisible(false);
                if (this.lookupControl && this.lookupControl.popupHostElement) {
                    // hide the lookup until the it closes
                    $(this.lookupControl.popupHostElement).css("display", "none");
                }
            };
            Company.prototype.toggleCompanyLookupVisible = function () {
                if (this.CompanyLookupVisible()) {
                    this.CompanyLookupVisible(false);
                }
                else {
                    this.CompanyLookupVisible(true);
                }
            };
            return Company;
        }($dyn.ui.Control));
        controls.Company = Company;
        $dyn.ui.addObservablePropertiesToPrototype(Company.prototype, {
            Company: "",
            CompanyName: "",
            ShowOnNavBar: true,
        });
        $dyn.adapter({ id: "CompanyButton", controlType: "Company", template: "CompanyButton" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Company.js.map
